import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const CkEditoComponent = (props: any) => {
  const { data, setData, placeholder,height ,onInputStart} = props;

  return (
    <CKEditor
      editor={ClassicEditor}
      config={{
        placeholder: placeholder,
        toolbar: [],
      }}
      data={data}
      onReady={(editor: any) => {
        editor.editing.view.change((writer: any) => {
          const root = editor.editing.view.document.getRoot();

          if (height) {
            writer.setStyle('height', height, root);
            writer.setStyle('min-height', height, root);
            writer.setStyle('max-height', height, root);
          }

          writer.setStyle('font-size', '14px', root);
        });
      }}
      onChange={(event: any, editor: any) => {
        const data = editor.getData();
        setData(data);
        if (onInputStart) onInputStart();
      }}
    />
  );
};

export default CkEditoComponent;
